// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3qrR5","actionsCol":"EnrolledClinics_actionsCol__2ThlS"};